<template>
  <div class="footbar_">
    <div class="con_">
      <div class="con_item2">
        <img src="../../../assets/medilink/logo1.svg" alt="" />
        <p>
          <span class="locicon"></span
          >{{
            $t('LOGIN[4]') ||
              '总部地址：北京市朝阳区建国门外大街丙24号，京泰大厦10层'
          }}
        </p>
        <p>
          <span class="phoneicon"></span>{{ $t('LOGIN[5]') || '联系方式：' }}400
          880 8820
        </p>
        <p>
          <span class="emailicon"></span
          >{{ $t('LOGIN[6]') || '邮&nbsp;&nbsp;编：' }}100022
        </p>
        <p>
          <span class="faxicon"></span>{{ $t('LOGIN[7]') || '传真：' }}+8610
          8453 9719
        </p>
        <p>
          <span class="websiteicon"></span
          >{{ $t('LOGIN[8]') || '网址：' }}www.medilink-global.com.cn
        </p>
      </div>
      <div class="con_item2 flex_">
        <div class="con_item3">
          <p class="bold">{{ $t('AMG[0]') || '关于中间带' }}</p>
          <a href=""
            ><router-link
              :to="{ path: '/MediLink/about', query: { loc: 1 } }"
              >{{ $t('AMG[1]') || '企业简介' }}</router-link
            ></a
          >
          <a href=""
            ><router-link
              :to="{ path: '/MediLink/about', query: { loc: 2 } }"
              >{{ $t('AMG[2]') || '发展历程' }}</router-link
            ></a
          >
          <a href=""
            ><router-link
              :to="{ path: '/MediLink/about', query: { loc: 3 } }"
              >{{ $t('AMG[3]') || '商业模式' }}</router-link
            ></a
          >
          <!-- <a href=""><router-link  :to="{path:'/MediLink/about',query:{loc:4}}">联系我们</router-link></a> -->
          <a href=""
            ><router-link
              :to="{ path: '/MediLink/about', query: { loc: 5 } }"
              >{{ $t('AMG[4]') || '合作伙伴' }}</router-link
            ></a
          >
          <a v-if="$i18n.locale != 'en-us'" href=""
            ><router-link
              :to="{ path: '/MediLink/about', query: { loc: 6 } }"
              >{{ $t('AMG[5]') || '招贤纳士' }}</router-link
            ></a
          >
        </div>
        <div class="con_item3">
          <p class="bold">{{ $t('AMG[6]') || '视频中心' }}</p>
          <!-- <a href=""><router-link  :to="{path:'/MediLink/videoCenter',query:{loc:1}}">董事长演讲</router-link></a>
           <a href=""><router-link  :to="{path:'/MediLink/videoCenter',query:{loc:2}}">中间带宣传片</router-link></a> -->
          <a href=""
            ><router-link :to="{ path: '/MediLink/videoCenter' }">{{
              $t('AMG[7]') || '企业活动片'
            }}</router-link></a
          >
        </div>
        <div class="con_item3">
          <p class="bold">{{ $t('AMG[8]') || '产品与服务' }}</p>
          <a href=""
            ><router-link :to="{ path: '/MediLink/product' }">{{
              $t('AMG[9]') || '第三方管理服务'
            }}</router-link></a
          >
          <a href=""
            ><router-link :to="{ path: '/MediLink/memberService' }">{{
              $t('AMG[10]') || '会员服务'
            }}</router-link></a
          >
          <!-- <a href=""><router-link :to="{path:'/MediLink/incrementService'}">增值服务</router-link></a> -->
          <!-- <a href=""><router-link :to="{path:'/MediLink/rescueService'}">紧急医疗援助</router-link></a> -->
          <a href=""
            ><router-link :to="{ path: '/MediLink/health' }">{{
              $t('AMG[11]') || '健康服务'
            }}</router-link></a
          >
          <a href="javascript:;"
            ><router-link :to="{ path: '/MediLink/hospital/mainland' }">{{
              $t('AMG[12]') || '查看医疗网络'
            }}</router-link></a
          >
        </div>
        <div class="con_item3">
          <p class="bold">{{ $t('AMG[13]') || '信息中心' }}</p>
          <a href=""
            ><router-link
              :to="{ path: '/MediLink/newsCenter', query: { loc: 1 } }"
              >{{ $t('AMG[14]') || '最新动态' }}</router-link
            ></a
          >
          <a href=""
            ><router-link
              :to="{ path: '/MediLink/newsCenter', query: { loc: 2 } }"
              >{{ $t('AMG[15]') || '媒体报道' }}</router-link
            ></a
          >
          <a href=""
            ><router-link
              :to="{ path: '/MediLink/newsCenter', query: { loc: 3 } }"
              >{{ $t('AMG[16]') || '常见问题' }}</router-link
            ></a
          >
          <a href=""
            ><router-link
              :to="{ path: '/MediLink/newsCenter', query: { loc: 4 } }"
              >{{ $t('AMG[17]') || '文件下载' }}</router-link
            ></a
          >
        </div>
      </div>
      <div class="con_item2 flex_">
        <div class="con_item4">
          <img src="../../../assets/medilink/saoma.png" alt="" />
          <span>{{ $t('AMG[18]') || '中间带在线' }}</span>
        </div>
        <div class="con_item4">
          <img src="../../../assets/medilink/erweima24.jpeg" alt="" />
          <span>{{ $t('AMG[19]') || '中间带24小时' }}</span>
        </div>
        <div class="con_item4">
          <img src="../../../assets/medilink/ma3.jpg" alt="" />
          <span>MediLink Global<br />中间带</span>
        </div>
      </div>
    </div>
    <p>
      Copyright © 2008 - {{ year }} MediLink-Global. ALL RIGHTS RESERVED
      京ICP备08007346号-1 京公网安备 11010502030494号
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
<style lang="scss" scoped>
.footbar_ {
  background: url(../../../assets/medilink/foot.png) center center no-repeat
    #141d33;
  background-size: 100% 100%;
  padding: 58px 0 0 0;
  .con_ {
    display: flex;
    justify-content: space-between;
    align-items: initial;
    font-size: 14px;
    padding: 0 83px;
    color: #fff;
    .con_item2 {
      &.flex_ {
        display: flex;
        justify-content: space-between;
      }
      &:first-child {
        // width:460px;
        width: 29%;
        img {
          width: 119px;
          height: 35px;
          object-fit: cover;
          margin-bottom: 30px;
        }
        p {
          // margin-bottom:20px;
        }
      }
      &:nth-child(2) {
        // width:510px;
        width: 33.4%;
        // margin-left: -151px;
      }
      &:last-child {
        // width:270px;
        width: 30%;
      }
      p {
        display: flex;
        align-items: center;
        justify-content: self-start;
      }
      .locicon {
        width: 15px;
        height: 15px;
        display: inline-block;
        background: url(../../../assets/medilink/locicon.png) center center
          no-repeat;
        background-size: 13px 17px;
        margin-right: 13px;
      }
      .phoneicon {
        width: 15px;
        height: 15px;
        display: inline-block;
        background: url(../../../assets/medilink/phoneicon.png) center center
          no-repeat;
        background-size: 15px 13px;
        margin-right: 13px;
      }
      .emailicon {
        width: 15px;
        height: 15px;
        display: inline-block;
        background: url(../../../assets/medilink/emailicon.png) center center
          no-repeat;
        background-size: 14px 11px;
        margin-right: 13px;
      }
      .faxicon {
        width: 15px;
        height: 15px;
        display: inline-block;
        background: url(../../../assets/medilink/faxicon.png) center center
          no-repeat;
        background-size: 14px 14px;
        margin-right: 13px;
      }
      .websiteicon {
        width: 15px;
        height: 15px;
        display: inline-block;
        background: url(../../../assets/medilink/websiteicon.png) center center
          no-repeat;
        background-size: 15px 15px;
        margin-right: 13px;
      }
      .con_item3 {
        display: flex;
        flex-direction: column;
        p {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        a {
          font-size: 14px;
          color: #fff;
          padding: 5px 0;
          opacity: 0.7;
          &:hover {
            opacity: 1;
          }
        }
      }
      .con_item4 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        // margin-right:33px;
        margin-top: -96px;
        width: 143px;
        align-items: center;
        img {
          width: 109px;
          height: 109px;
          object-fit: cover;
          margin-bottom: 5px;
        }
        &:last-child {
          margin-right: 0;
          margin-top: -75px;
          span {
            // white-space:nowrap;
            text-align: center;
          }
        }
      }
    }
  }
  & > p {
    margin-top: 38px;
    text-align: center;
    padding: 12px 0;
    color: #fff;
    font-size: 12px;
    background: rgba(9, 15, 31, 0.7);
  }
}
</style>
